/// <amd-module name="Build/PipelinesLanguage/Services/MonacoLanguageRegistrationService" />

export interface IMonacoLanguageRegistrationService {
    register(language: monaco.languages.ILanguageExtensionPoint): void;
    registerCompletionItemProvider(languageId: string, provider: monaco.languages.CompletionItemProvider): monaco.IDisposable;
    registerDocumentRangeFormattingEditProvider(languageId: string, provider: monaco.languages.DocumentRangeFormattingEditProvider): monaco.IDisposable;
    registerDocumentSymbolProvider(languageId: string, provider: monaco.languages.DocumentSymbolProvider): monaco.IDisposable;
    registerHoverProvider(languageId: string, provider: monaco.languages.HoverProvider): monaco.IDisposable;
    registerCodeLensProvider(languageId: string, provider: monaco.languages.CodeLensProvider): monaco.IDisposable;
}

export const monacoLanguageRegistrationService = (): IMonacoLanguageRegistrationService => ({
    register: monaco.languages.register,
    registerCompletionItemProvider: monaco.languages.registerCompletionItemProvider,
    registerDocumentRangeFormattingEditProvider: monaco.languages.registerDocumentRangeFormattingEditProvider,
    registerDocumentSymbolProvider: monaco.languages.registerDocumentSymbolProvider,
    registerHoverProvider: monaco.languages.registerHoverProvider,
    registerCodeLensProvider: monaco.languages.registerCodeLensProvider,
});
